<template>
  <div class="clearfix prices-grid">
    <ul class="col-xs-4 text-right">
      <li>
        <strong>Melhor preço<span class="hidden-xs"> por companhia</span></strong>
      </li>
      <template v-if="!active">
        <li
          v-for="(stop, index) in stops"
          :key="`lowest-price-${index}`">
          <template v-if="Number(stop) >= 1">
            {{ stop }}
            <template v-if="Number(stop) === 1">parada</template>
            <template v-else>paradas <span class="hidden-xs">ou mais</span></template>
          </template>
          <template v-else>
            direto
          </template>
        </li>
      </template>
    </ul>
    <div class="col-xs-8">
      <template v-if="!active">
        <ul
          v-for="(carrierName, carrierCode) in carriers"
          :key="`prices-grid-carrier-${carrierName}`"
          :class="[`col-xs-${12/Object.keys(carriers).length}`, Object.keys(carriers).length > 1 ? 'text-center' : 'text-left']">
          <li class="prices-grid-carrier">
            <carrier-image :imageSrc="carrierCode"></carrier-image>
            {{ carrierName }}
          </li>
          <li
            v-for="(stop) in stops"
            :key="`prices-grid-stops-${stop}`">
            <template v-if="lowestPrices[stop][carrierCode]">
              <span
                :class="{ 'active' : lowestPrices[stop][carrierCode]['bestPrice'] }"
                class="prices-grid-handle"
                href="#">
                {{ lowestPrices[stop][carrierCode]['value'] | brlPrice }}
              </span>
            </template>
            <template v-else>
              <span class="prices-grid-handle"
                href="#">
              </span>
            </template>
          </li>
        </ul>
      </template>
      <template v-else>
        <ul class="col-xs-12">
          <li>
            <template v-if="selected.stops > 1">
              {{ selected.stops }} {{ selected.stops === 1 ? `parada`: `paradas ou mais`}}
            </template>
            <template v-else>
              direto
            </template> |
            <span class="prices-grid-carrier text-center">
              <carrier-image :imageSrc="selected.iata_code"></carrier-image>
              {{ carriers[selected.iata_code] }}
            </span> | <span>{{ selected.lowest_price | brlPrice }}</span>
            <button
              type="button"
              class="pull-right prices-grid-remove">
              X remover
            </button>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
import CarrierImage from '@/components/CarrierImage'

export default {
  props: [
    'lowestPrices'
  ],
  components: {
    CarrierImage
  },
  data() {
    return {
      selected: {},
      active: false,
      carriers: {},
      stops: []
    }
  },
  mounted(){
    this.stops = Object.keys(this.lowestPrices)
    for(const key in this.lowestPrices){
      const value = this.lowestPrices[key]
      let bestPrice = Infinity
      for (const carrier in value) {
        
        // New best price for this carrier with this quantity of stops
        if(this.lowestPrices[key][carrier]['value'] < bestPrice){
          bestPrice = this.lowestPrices[key][carrier]['value']
        }

        if(!Object.keys(this.carriers).includes(carrier)){
          this.carriers[carrier] = this.lowestPrices[key][carrier]['name']
        }
      }

      // Set bestPrice in the props 
      Object.keys(this.lowestPrices[key]).forEach((el=>{
        this.lowestPrices[key][el]['bestPrice'] = this.lowestPrices[key][el]['value'] === bestPrice ? true : false;
      }))
    }
  },

};
</script>

<style lang="scss">
@import '@/scss/views/flights/search/PricesGrid';
</style>